// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  confirm: 'Leave',
  cancel: 'Go Back',
  content: "Are you sure you want to close and leave this window? Any data changes you've made won't be saved."
};